import React from 'react'
import { SpinnerWrapper } from './Spinner.styles'
import { theme } from './StrategyBlock.styles'

const Spinner = ({ isLarge = false }) => {
  return (
    <SpinnerWrapper isLarge={isLarge}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        x="0"
        y="0"
        version="1.1"
        viewBox="0 0 100 100"
        xmlSpace="preserve"
      >
        <path
          fill={theme.colors.orangeDark}
          d="M73 50c0-12.7-10.3-23-23-23S27 37.3 27 50m3.9 0c0-10.5 8.5-19.1 19.1-19.1S69.1 39.5 69.1 50"
        >
        </path>
      </svg>
    </SpinnerWrapper>
  )
}

export default Spinner
